import axios from 'axios'
import {ElMessage, ElMessageBox} from 'element-plus'
import cookie from '@/utils/cookie'
import router from '@/router'
import store from '@/store'

const request = axios.create({
    timeout: 10000,
    withCredentials: true,
    baseURL: process.env.VUE_APP_API_BASE_URL
})

const requestStack: any = {} // 请求栈
const requestStackWhiteList = [/\/admin\/goods\/(\d+)\/upload-pic/] // 请求栈白名单

/**
 * 删除请求栈
 * @param keyName
 */
const trashRequestStack = (keyName: string): void => {
    // eslint-disable-next-line no-prototype-builtins
    if (keyName && requestStack.hasOwnProperty(keyName)) {
        setTimeout(() => {
            delete requestStack[keyName]
        }, 1000)
    }
}

// Request拦截器
request.interceptors.request.use(
    config => {
        const token = store.getters.token || cookie.get('token')
        if (token && config.headers) {
            config.headers['token'] = token
        }
        const url = config.url ? config.url : ''
        // 将post请求加入到请求栈
        if (config.method?.toLowerCase() === 'post' && !requestStackWhiteList.find(p => p.test(url))) {
            const source = axios.CancelToken.source()
            config.cancelToken = source.token
            // eslint-disable-next-line no-prototype-builtins
            if (requestStack.hasOwnProperty(url)) { // 如果post请求栈还存在，提示重复请求
                source.cancel('请求重复')
            } else {
                requestStack[url] = source
            }
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// Response拦截器
request.interceptors.response.use(
    response => {
        const url = response.config.url || ''
        const baseUrl = response.config.baseURL || ''
        trashRequestStack(url.replace(baseUrl, ''))
        if (response.status === 200) {
            if (response.headers.token) {
                cookie.set('token', response.headers.token)
            }
            return response.data
        }
    },
    error => {
        const url = error.config ? error.config.url : ''
        const baseUrl = error.config ? error.config.baseURL : ''
        trashRequestStack(url.replace(baseUrl, ''))
        let message = error.message || ''
        const status = error.response ? error.response.status : 420
        if (error.code === 'ECONNABORTED') message = '网络连接超时，请重试'
        if (error.code === 'ERR_NETWORK') message = '网络连接错误，请检查网络后重试'
        if (error.code === 'ERR_BAD_RESPONSE' || error.code === 'ERR_BAD_REQUEST') message = error.response.data?.message || ''
        if (!error.config.silence) {
            if (status === 420 || status === 500) {
                ElMessage({
                    message,
                    type: 'error',
                    duration: status === 420 ? 3000 : 0,
                    showClose: true,
                    offset: 5
                })
            } else if (status === 401) {
                const messageAlert = store.getters.messageAlert
                if (!messageAlert) {
                    ElMessageBox.alert(message, '登录提示', {
                        confirmButtonText: '确定',
                        callback: () => {
                            const redirect = encodeURIComponent(window.location.pathname)
                            router.push({path: '/login', query: {redirect}}).then(() => {
                                cookie.del('token')
                                cookie.del('admin')
                                store.commit('setAdmin', {})
                                store.commit('setMessageAlert', false)
                            })
                        }
                    }).then(r => {
                        console.log(r)
                    })
                    store.commit('setMessageAlert', true)
                }
            }
        }

        return Promise.reject(error)
    }
)

export default request
